<template>
  <div style="background-color: lightgray">
    <van-form>
      <van-radio-group v-if="!isDouy" v-model="customer.plateformSerNum" direction="horizontal">
        <van-tabs v-model="customer.tabSelected" style="width: 100%;" line-width="0">
          <van-tab :name="1">
            <template #title>
              <van-radio name="1">{{ plateform[0].plateFormName }}
                <span>{{ plateform[0].areadyUseNum }}/{{ plateform[0].plateFormTotalNum }}</span>
              </van-radio>
            </template>
            <van-row>
              <van-col span="24">
                <van-cell-group>
                  <van-field
                      v-model="customer.plateformUsername"
                      label="平台会员名:"
                      placeholder="淘宝会员名"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <van-field
                      v-model="customer.taoValue"
                      label="淘气值:"
                      placeholder="0"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field
                        readonly
                        clickable
                        name="picker"
                        label="账号等级"
                        placeholder="无"
                        @click="showPicker = true"
                        is-link
                        input-align="right"
                    >
                      <template #input>
                        <div v-if="customer.accountLeave.id == 0">
                          无
                        </div>
                        <div v-if="customer.accountLeave.id == 1">
                          <i class="A"  v-for="i in customer.accountLeave.diamondsLevel">
                          </i>
                        </div>
                        <div v-if="customer.accountLeave.id == 2">
                          <i class="B"  v-for="i in customer.accountLeave.diamondsLevel">
                          </i>
                        </div>
                        <div v-if="customer.accountLeave.id == 3">
                          <i class="C"  v-for="i in customer.accountLeave.diamondsLevel">
                          </i>
                        </div>
                        <div v-if="customer.accountLeave.id == 4">
                          <i class="D"  v-for="i in customer.accountLeave.diamondsLevel">
                          </i>
                        </div>
                      </template>
                    </van-field>
                    <van-popup v-model="showPicker" position="bottom">
                      <van-picker
                          show-toolbar
                          :columns="columns"
                          @confirm="onConfirm"
                          @cancel="showPicker = false"
                      >
                        <template #option="item">
                          <div v-if="item.id == 0">
                            无
                          </div>
                          <div v-if="item.id == 1">
                            <i class="A"  v-for="i in item.diamondsLevel">
                            </i>
                          </div>
                          <div v-if="item.id == 2">
                            <i class="B"  v-for="i in item.diamondsLevel">
                            </i>
                          </div>
                          <div v-if="item.id == 3">
                            <i class="C"  v-for="i in item.diamondsLevel">
                            </i>
                          </div>
                          <div v-if="item.id == 4">
                            <i class="D"  v-for="i in item.diamondsLevel">
                            </i>
                          </div>
                        </template>
                      </van-picker>
                    </van-popup>
                  </div>
                  <van-field label="是否开通花呗:" input-align="right" label-width="100">
                    <template #input>
                      <van-radio-group v-model="customer.aliyunPay" direction="horizontal">
                        <van-radio :name="false">否</van-radio>
                        <van-radio :name="true">是</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <van-field label="性别:" input-align="right">
                    <template #input>
                      <van-radio-group v-model="customer.plateformSex" direction="horizontal">
                        <van-radio :name="false">女</van-radio>
                        <van-radio :name="true">男</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <van-field
                      v-model="customer.plateformAge"
                      label="年龄:"
                      placeholder="请填写年龄"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <van-field
                      v-model="customer.orderNum"
                      placeholder="请复制该淘宝会员任意一个订单号"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="left"
                  />
                  <van-field readonly >
                    <template #input>
                      <span style="color: red;font-size: smaller">
                        <van-icon name="warning-o" />
                        注意：请认真填写订单编号！否则会引起做单和返款失败。
                      </span>
                    </template>
                  </van-field>
                  <div>
                    <van-field
                        readonly
                        clickable
                        label="收货地区:"
                        :value="customer.expressAddr"
                        placeholder="请选择地区"
                        @click="showAddrPicker = true"
                        is-link
                        input-align="right"
                    />
                    <van-popup v-model="showAddrPicker" round position="bottom">
                      <van-area
                          title="选择收货地址"
                          :area-list="backAddrInfo"
                          ref="myArea"
                          @confirm="onAddrConfirm"
                          @cancel="onAddrCancel"
                          @change="onAddrChange"
                      />
                    </van-popup>
                    <van-field
                        v-model="customer.addressDetail"
                        placeholder="收货详细地址"
                        :rules="[{ required:true, message: '请输入正确内容' }]"
                        input-align="right"
                    />
                  </div>
                </van-cell-group>
                <van-row gutter="0">
                  <van-col span="24">
                    <div style="min-height: 44px;line-height: 44px;color: darkgray;margin-top: 2%;font-size: smaller">
                      <span style="margin-left: 5%;">注意事项</span>
                    </div>
                    <van-field readonly >
                      <template #input>
                      按照提示绑号即可
                      </template>
                    </van-field>
                  </van-col>
                </van-row>
                <van-row gutter="0">
                  <van-col span="24">
                    <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller">
                      <span style="margin-left: 5%;">支付宝个人信息</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row gutter="0" style="background-color: white">
                  <div style="margin: 2%;padding-top: 2%;">
                    <van-col span="11" >
                      <van-field name="IdCardBUrl" >
                        <template #input>
                          <van-uploader accept="image/*" :max-count="1" v-model="imageFile" :after-read="afterImages" :before-delete="deleteImage">
                          </van-uploader>
                        </template>
                      </van-field>
                    </van-col>
                    <van-col span="2">
                      <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
                    </van-col>
                    <van-col span="11">
                      <van-image
                          @click="perviewImage(imageIdCard)"
                          :src="imageIdCard"></van-image>
                    </van-col>
                  </div>
                </van-row>
              </van-col>
            </van-row>
          </van-tab>
          <van-tab :name="2">
            <template #title>
              <van-radio name="2">{{ plateform[1].plateFormName }}
                <span>{{ plateform[1].areadyUseNum }}/{{ plateform[1].plateFormTotalNum }}</span></van-radio>
            </template>
            <van-row>
              <van-col span="24">
                <van-cell-group>
                  <van-field
                      v-model="customer.plateformUsername"
                      label="平台会员名:"
                      placeholder="京东会员名"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <van-field label="性别:" input-align="right">
                    <template #input>
                      <van-radio-group v-model="customer.plateformSex" direction="horizontal">
                        <van-radio :name="false">女</van-radio>
                        <van-radio :name="true">男</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <van-field
                      v-model="customer.plateformAge"
                      label="年龄:"
                      placeholder="请填写年龄"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field
                        readonly
                        clickable
                        label="收货地区:"
                        :value="customer.expressAddr"
                        placeholder="请选择地区"
                        @click="showAddrPicker = true"
                        is-link
                        input-align="right"
                    />
                    <van-popup v-model="showAddrPicker" round position="bottom">
                      <van-area
                          title="选择收货地址"
                          :area-list="backAddrInfo"
                          ref="myArea"
                          @confirm="onAddrConfirm"
                          @cancel="onAddrCancel"
                          @change="onAddrChange"
                      />
                    </van-popup>
                    <van-field
                        v-model="customer.addressDetail"
                        placeholder="收货详细地址"
                        :rules="[{ required:true, message: '请输入正确内容' }]"
                        input-align="right"
                    />
                  </div>
                </van-cell-group>
              </van-col>
            </van-row>
            <!--<van-row gutter="0" >
              <van-col span="24">
                <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
                  <van-button :disabled="plateform[1].areadyUseNum == plateform[1].plateFormTotalNum" type="info" style="margin: 5%;width: 200px;" native-type="submit">保存</van-button>
                </div>
              </van-col>
            </van-row>-->
          </van-tab>
          <van-tab :name="3">
            <template #title>
              <van-radio name="3">{{ plateform[2].plateFormName }}
                <span>{{ plateform[2].areadyUseNum }}/{{ plateform[2].plateFormTotalNum }}</span></van-radio>
            </template>
            <van-row>
              <van-col span="24">
                <van-cell-group>
                  <van-field
                      v-model="customer.plateformUsername"
                      label="平台会员名:"
                      placeholder="拼多多会员名"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <van-field label="性别:" input-align="right">
                    <template #input>
                      <van-radio-group v-model="customer.plateformSex" direction="horizontal">
                        <van-radio :name="false">女</van-radio>
                        <van-radio :name="true">男</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <van-field
                      v-model="customer.plateformAge"
                      label="年龄:"
                      placeholder="请填写年龄"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field
                        readonly
                        clickable
                        label="收货地区:"
                        :value="customer.expressAddr"
                        placeholder="请选择地区"
                        @click="showAddrPicker = true"
                        is-link
                        input-align="right"
                    />
                    <van-popup v-model="showAddrPicker" round position="bottom">
                      <van-area
                          title="选择收货地址"
                          :area-list="backAddrInfo"
                          ref="myArea"
                          @confirm="onAddrConfirm"
                          @cancel="onAddrCancel"
                          @change="onAddrChange"
                      />
                    </van-popup>
                    <van-field
                        v-model="customer.addressDetail"
                        placeholder="收货详细地址"
                        :rules="[{ required:true, message: '请输入正确内容' }]"
                        input-align="right"
                    />
                  </div>
                </van-cell-group>
              </van-col>
            </van-row>
            <!--<van-row gutter="0" >
              <van-col span="24">
                <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
                  <van-button :disabled="plateform[2].areadyUseNum == plateform[2].plateFormTotalNum" type="info" style="margin: 5%;width: 200px;" native-type="submit">保存</van-button>
                </div>
              </van-col>
            </van-row>-->
          </van-tab>
          <van-tab :name="4">
            <template #title>
              <van-radio name="4">{{ plateform[3].plateFormName }}
                <span>{{ plateform[3].areadyUseNum }}/{{ plateform[3].plateFormTotalNum }}</span></van-radio>
            </template>
            <van-row>
              <van-col span="24">
                <van-cell-group>
                  <van-field
                      v-model="customer.plateformUsername"
                      label="平台会员名:"
                      placeholder="抖音会员名"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <van-field label="性别:" input-align="right">
                    <template #input>
                      <van-radio-group v-model="customer.plateformSex" direction="horizontal">
                        <van-radio :name="false">女</van-radio>
                        <van-radio :name="true">男</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <van-field
                      v-model="customer.plateformAge"
                      label="年龄:"
                      placeholder="请填写年龄"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field
                        readonly
                        clickable
                        label="收货地区:"
                        :value="customer.expressAddr"
                        placeholder="请选择地区"
                        @click="showAddrPicker = true"
                        is-link
                        input-align="right"
                    />
                    <van-popup v-model="showAddrPicker" round position="bottom">
                      <van-area
                          title="选择收货地址"
                          :area-list="backAddrInfo"
                          ref="myArea"
                          @confirm="onAddrConfirm"
                          @cancel="onAddrCancel"
                          @change="onAddrChange"
                      />
                    </van-popup>
                    <van-field
                        v-model="customer.addressDetail"
                        placeholder="收货详细地址"
                        :rules="[{ required:true, message: '请输入正确内容' }]"
                        input-align="right"
                    />
                  </div>
                </van-cell-group>
                <!--<van-row gutter="0">
                  <van-col span="24">
                    <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller">
                      <span style="margin-left: 5%;">抖音账号截图</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row gutter="0" style="background-color: white">
                  <div style="margin: 2%;padding-top: 2%;">
                    <van-col span="11" >
                      <van-field name="IdCardBUrl" >
                        <template #input>
                          <van-uploader accept="image/*" :max-count="1" v-model="imageFile" :after-read="afterImages" >
                          </van-uploader>
                        </template>
                      </van-field>
                    </van-col>
                    <van-col span="2">
                      <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
                    </van-col>
                    <van-col span="11">
                      <van-image
                          @click="perviewImage(imageDyUrl)"
                          :src="imageDyUrl"></van-image>
                    </van-col>
                  </div>
                </van-row>-->
              </van-col>
            </van-row>
            <!--<van-row gutter="0" >
              <van-col span="24">
                <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
                  <van-button :disabled="plateform[3].areadyUseNum == plateform[3].plateFormTotalNum" type="info" style="margin: 5%;width: 200px;" native-type="submit">保存</van-button>
                </div>
              </van-col>
            </van-row>-->
          </van-tab>
          <van-tab :name="5">
            <template #title>
              <van-radio name="5">{{ plateform[4].plateFormName }}
                <span>{{ plateform[4].areadyUseNum }}/{{ plateform[4].plateFormTotalNum }}</span></van-radio>
            </template>
            <van-row>
              <van-col span="24">
                <van-cell-group>
                  <van-field
                      v-model="customer.plateformUsername"
                      label="平台会员名:"
                      placeholder="阿里巴巴会员名"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <van-field label="性别:" input-align="right">
                    <template #input>
                      <van-radio-group v-model="customer.plateformSex" direction="horizontal">
                        <van-radio :name="false">女</van-radio>
                        <van-radio :name="true">男</van-radio>
                      </van-radio-group>
                    </template>
                  </van-field>
                  <van-field
                      v-model="customer.plateformAge"
                      label="年龄:"
                      placeholder="请填写年龄"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field
                        readonly
                        clickable
                        label="收货地区:"
                        :value="customer.expressAddr"
                        placeholder="请选择地区"
                        @click="showAddrPicker = true"
                        is-link
                        input-align="right"
                    />
                    <van-popup v-model="showAddrPicker" round position="bottom">
                      <van-area
                          title="选择收货地址"
                          :area-list="backAddrInfo"
                          ref="myArea"
                          @confirm="onAddrConfirm"
                          @cancel="onAddrCancel"
                          @change="onAddrChange"
                      />
                    </van-popup>
                    <van-field
                        v-model="customer.addressDetail"
                        placeholder="收货详细地址"
                        :rules="[{ required:true, message: '请输入正确内容' }]"
                        input-align="right"
                    />
                  </div>
                </van-cell-group>
              </van-col>
            </van-row>
            <!--<van-row gutter="0" >
              <van-col span="24">
                <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
                  <van-button :disabled="plateform[4].areadyUseNum == plateform[4].plateFormTotalNum" type="info" style="margin: 5%;width: 200px;" native-type="submit">保存</van-button>
                </div>
              </van-col>
            </van-row>-->
          </van-tab>
          <van-tab disabled>
          </van-tab>
        </van-tabs>
      </van-radio-group>
      <van-radio-group v-else v-model="customer.plateformSerNum" direction="horizontal">
        <van-tabs v-model="customer.tabSelected" style="width: 100%;" line-width="0">
          <van-tab>
            <template #title>
              <van-radio name="1">{{ plateform[0].plateFormName }}
                <span>{{ plateform[0].areadyUseNum }}/{{ plateform[0].plateFormTotalNum }}</span>
              </van-radio>
            </template>
            <van-row>
              <van-col span="24">
                <van-cell-group>
                  <van-field
                      v-model="customer.plateformUsername"
                      label="平台会员名:"
                      placeholder="抖音会员名"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field label="性别:" input-align="right">
                      <template #input>
                        <van-radio-group v-model="customer.plateformSex" direction="horizontal">
                          <van-radio :name="false">女</van-radio>
                          <van-radio :name="true">男</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>
                  </div>
                  <van-field
                      v-model="customer.plateformAge"
                      label="年龄:"
                      placeholder="请填写年龄"
                      type="number"
                      :rules="[{ required:true, message: '请输入正确内容' }]"
                      input-align="right"
                  />
                  <div>
                    <van-field
                        readonly
                        clickable
                        label="收货地区:"
                        :value="customer.expressAddr"
                        placeholder="请选择地区"
                        @click="showAddrPicker = true"
                        is-link
                        input-align="right"
                    />
                    <van-popup v-model="showAddrPicker" round position="bottom">
                      <van-area
                          title="选择收货地址"
                          :area-list="backAddrInfo"
                          ref="myArea"
                          @confirm="onAddrConfirm"
                          @cancel="onAddrCancel"
                          @change="onAddrChange"
                      />
                    </van-popup>
                    <van-field
                        v-model="customer.addressDetail"
                        placeholder="收货详细地址"
                        :rules="[{ required:true, message: '请输入正确内容' }]"
                        input-align="right"
                    />
                  </div>
                </van-cell-group>
                <van-row gutter="0">
                  <van-col span="24">
                    <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller">
                      <span style="margin-left: 5%;">抖音账号截图</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row gutter="0" style="background-color: white">
                  <div style="margin: 2%;padding-top: 2%;">
                    <van-col span="11" >
                      <van-field name="IdCardBUrl" >
                        <template #input>
                          <van-uploader accept="image/*" :max-count="1" v-model="imageFile" :after-read="afterImages" >
                          </van-uploader>
                        </template>
                      </van-field>
                    </van-col>
                    <van-col span="2">
                      <div style="padding: 16px 6px 1px;margin-left: 12px;border-left: 1px solid;font-size: 0;height: 210px;"></div>
                    </van-col>
                    <van-col span="11">
                      <van-image
                          @click="perviewImage(imageDyUrl)"
                          :src="imageDyUrl"></van-image>
                    </van-col>
                  </div>
                </van-row>
              </van-col>
            </van-row>
            <!--<van-row gutter="0" >
              <van-col span="24">
                <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
                  <van-button :disabled="plateform[0].areadyUseNum == plateform[0].plateFormTotalNum" type="info" style="margin: 5%;width: 200px;" native-type="submit">保存</van-button>
                </div>
              </van-col>
            </van-row>-->
          </van-tab>
        </van-tabs>
      </van-radio-group>
      <van-row gutter="0" >
        <van-col span="24">
          <div style="min-height: 33px;line-height: 33px;color: darkgray;margin-top: 2%;font-size: smaller; text-align: center;">
            <van-button type="info" style="margin: 5%;width: 200px;" @click="onSubmit(customer)">保存</van-button>
          </div>
        </van-col>
      </van-row>
    </van-form>
  </div>
</template>

<script>
import {areaList} from "@vant/area-data";
import {ImagePreview} from "vant";
import {uploaderToServer} from "../../api/system/sys_backInfo";
import {addPlateformAccount, getPlateformAccount, getPlateformAccountInfo} from "../../api/system/sys_plateform";
import {MessageBox, Toast} from "mint-ui";
import {isStrEmpty} from "../../lib/utils";

export default {
  name: "AddPlateformAccount",
  data() {
    return {
      customer: {
        plateformSerNum: '1',
        tabSelected: 1,
        plateformUsername: "",
        accountLeave: {
          id:0,
          diamondsLevel: 0,
          value: 0
        },
        taoValue:0,
        aliyunPay:true,
        plateformSex:false,
        plateformAge:"",
        orderNum:"",
        expressAddr:"",
        addressDetail:"",
        imageUrl:""
      },
      showAddrPicker:false,
      backAddrInfo:areaList,
      columns: [
        {
          id:0,
          diamondsLevel: 0,
        },
        {
          id:1,
          diamondsLevel: 1,
          value: 4
        },
        {
          id:1,
          diamondsLevel: 2,
          value: 11
        },
        {
          id:1,
          diamondsLevel: 3,
          value: 41
        },
        {
          id:1,
          diamondsLevel: 4,
          value: 91
        },
        {
          id:1,
          diamondsLevel: 5,
          value: 151
        },
        {
          id:2,
          diamondsLevel: 1,
          value: 251
        },
        {
          id:2,
          diamondsLevel: 2,
          value: 501
        },
        {
          id:2,
          diamondsLevel: 3,
          value: 1001
        },
        {
          id:2,
          diamondsLevel: 4,
          value: 2001
        },
        {
          id:2,
          diamondsLevel: 5,
          value: 5001
        },
        {
          id:3,
          diamondsLevel: 1,
          value: 10001
        },
        {
          id:3,
          diamondsLevel: 2,
          value: 20001
        },
        {
          id:3,
          diamondsLevel: 3,
          value: 50001
        },
        {
          id:3,
          diamondsLevel: 4,
          value: 100001
        },
        {
          id:3,
          diamondsLevel: 5,
          value: 200001
        },
        {
          id:4,
          diamondsLevel: 1,
          value: 500001
        },
        {
          id:4,
          diamondsLevel: 2,
          value: 1000001
        },
        {
          id:4,
          diamondsLevel: 3,
          value: 2000001
        },
        {
          id:4,
          diamondsLevel: 4,
          value: 5000001
        },
        {
          id:4,
          diamondsLevel: 5,
          value: 10000001
        }

      ],
      showPicker: false,
      isDouy: false,
      plateform: [
        {
          name: "淘宝",
          useNum: 1,
          useTotal: 3
        },
        {
          name: "京东",
          useNum: 0,
          useTotal: 2
        },
        {
          name: "拼多多",
          useNum: 0,
          useTotal: 2
        },
        {
          name: "抖音",
          useNum: 0,
          useTotal: 2
        },
        {
          name: "阿里巴巴",
          useNum: 0,
          useTotal: 3
        },
      ],
      imageFile:[],
      imageIdCard:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/image3.jpg",
      imageDyUrl:"https://myb2c.oss-cn-hangzhou.aliyuncs.com/admin/image0.jpg"
    }
  },
  mounted() {
    this.$emit("titleChange", "添加账号");
    getPlateformAccountInfo().then(res=>{
      if (res.success){
        console.log(res.data)
        this.plateform = res.data;
        if (res.data.length < 2){
          this.isDouy = true;
        }else{
          this.isDouy = false;
        }
      }
      this.$forceUpdate();
    });
    if (this.$route.query.id != null){
      getPlateformAccount(this.$route.query.id).then(res=>{
        if (res.success){
          this.customer = res.data;
          this.imageFile.push({url:this.customer.imageUrl, isImage:true});
        }
      }).catch(err => {
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
      });
    }
  },
  methods: {
    perviewImage(imgUrl){
      ImagePreview({
        images: [
          imgUrl
        ],
        closeable: true,
      });
    },
    onSubmit(values) {
      if (this.isDouy){
        values.plateformSerNum = 4;
      }
      if (values.tabSelected==0&&isStrEmpty(values.imageUrl)){
        MessageBox({
          title: '提示',
          message: "请确保已上传图片信息",
          showCancelButton: true
        });
      }else if(values.plateformAge == null || values.plateformAge <= 0){
        MessageBox({
          title: '提示',
          message: "请填写年龄",
          showCancelButton: true
        });
      }else {
        addPlateformAccount(values).then(res => {
          if (res.success) {
            Toast({message: res.data, type: 'success'});
            this.$router.back();
          }
        }).catch(err => {
          MessageBox({
            title: '提示',
            message: err.message,
            showCancelButton: true
          });
        });
      }
    },
    onConfirm(value, index) {
      console.log(value)
      this.customer.accountLeave = value;
      this.showPicker = false;
    },
    onAddrConfirm(value, index) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      this.customer.expressAddr = value[0].name+","+value[1].name+","+value[2].name;
      this.showAddrPicker = false;
    },
    onAddrChange(picker, index, value) {
      //Toast(`当前值：${value}, 当前索引：${index}`);
      let val = picker.getValues();
      console.log(val)//查看打印
      let areaName = ''
      for (let i = 0; i < val.length; i++) {
        areaName = areaName+(i==0?'':'/')+val[i].name
      }
      this.customer.expressAddr = areaName;
      //this.showAddrPicker = false;
    },
    onAddrCancel() {
      //Toast('取消');
      this.showAddrPicker = false;
      this.$refs.myArea.reset()// 重置城市列表
    },
    deleteImage(file){
      console.log("deleteImage")
      this.customer.imageUrl = null;
      return true;
    },
    afterImages(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res=>{
        if (res.success){
          file.status = 'success';
          file.message = '上传成功';
          this.customer.imageUrl=res.data;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .van-tab {
  flex: 0 0 auto !important;
}

i.A {
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/A.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }

 i.B{
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/B.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }

  i.C{
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/C.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }


  i.D{
    width: 20px;
    height: 20px;
    line-height: 20px;
    background-image: url(../../assets/img/D.gif);
    background-position: center center;
    background-repeat: no-repeat;
    display: inline-block;
  }

::v-deep .van-uploader__upload{
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  width: 128px;
  height: 225px;
  margin: 0 8px 8px 0;
  background-color: #f7f8fa;
}

::v-deep .van-uploader__preview-image{
  display: block;
  width: 128px;
  height: 225px;
  overflow: hidden;
}

</style>
